export const verifyResultIsContainData = (result) => {
  return result.some(
    (project) =>
      project?.projectCompletionUrls?.length > 0 || project?.files?.length > 0
  );
};
